module.exports = __webpack_public_path__ + "img/logo.dafeb890.svg";